import React, { useRef } from 'react';
import { string, arrayOf, shape, func } from 'prop-types';
import classnames from 'classnames';
import useAllImagesLoaded from 'components/UI/Image/useAllImagesLoaded';
import { EXPORT_READY_CLASSNAME, preferImage } from 'components/Exports/utils';
import ExportPlacementView from '../View/Export';

function PlacementExportList({
  cbn,
  data,
  metricsDisplay,
  renderLabel,
  shouldRender,
  values,
}) {
  const wrapperRef = useRef(null);
  const ready = useAllImagesLoaded(wrapperRef);

  const placements = data.map((placement) => ({
    ...placement,
    media: preferImage(placement.media),
  }));

  return (
    <div
      ref={wrapperRef}
      className={classnames(`${cbn}__wrapper`, {
        [EXPORT_READY_CLASSNAME]: ready,
      })}
    >
      {placements.map((p) => (
        <ExportPlacementView
          key={p.id}
          filters={values}
          placement={p}
          metricsDisplay={metricsDisplay}
          renderLabel={renderLabel}
          shouldRender={shouldRender}
          showGalleryThumbs={false}
          showHeaderAndFooter
        />
      ))}
    </div>
  );
}

PlacementExportList.propTypes = {
  cbn: string.isRequired,
  data: arrayOf(shape({})).isRequired,
  metricsDisplay: shape({}),
  renderLabel: func.isRequired,
  shouldRender: func.isRequired,
  values: shape({}),
};

PlacementExportList.defaultProps = {
  metricsDisplay: undefined,
  values: undefined,
};

export default PlacementExportList;
